import ComponentManager from "../../componentFramework";

declare function require(moduleName: string): any;
const autosize = require("autosize"); // http://www.jacklmoore.com/autosize/

@ComponentManager.register()
export default class AutosizeTextarea {
	public static componentStyleClass = "autosizeTextarea";

	constructor(private readonly rootElement: HTMLElement) {
		autosize(rootElement);
	}

	@ComponentManager.on("removed")
	protected componentRemoved() {
		autosize.destroy(this.rootElement);
	}
}
